import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  caseInsert (params) {
    return axios.post(global.CMS_BASE + '/case/insertWebCase', params)
  },
  caseUpdate (params) {
    return axios.post(global.CMS_BASE + '/case/updateWebCase', params)
  },
  caseDelete (params) {
    return axios.post(global.CMS_BASE + '/case/deleteWebCase', params)
  },
  caseDeleteInfo (params) {
    return axios.post(global.CMS_BASE + '/case/deleteWebCaseInfo', params)
  },
  caseTypeFindAll (param) {
    return axios.post(global.CMS_BASE + '/caseType/findAllWebCaseType', param)
  },
  caseTypeInsert (params) {
    return axios.post(global.CMS_BASE + '/caseType/insertWebCaseType', params)
  },
  caseTypeUpdate (params) {
    return axios.post(global.CMS_BASE + '/caseType/updateWebCaseType', params)
  },
  caseTypeDelete (params) {
    return axios.post(global.CMS_BASE + '/caseType/deleteWebCaseType', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/cms/caseList.js